import './DataSecurityViewContainer.scss';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { getClosestCardHeader } from '@lib/popups';
import { SonarCard } from '@ui/general';
import { VerticalColumnView } from '@ui/general/VerticalColumnView';
import { AppGroupSelect, AppSelect } from '@ui/applications';
import { DateRangePicker } from '@ui/DateRangePicker';
import React, { useCallback, useEffect } from 'react';
import { Row, Space } from 'antd';
import { useApplicationReference, useDataSecurityApps, useOnMount, useSonarSelector } from '@hooks';
import { useNavigate, useParams } from 'react-router-dom';
export const DataSecurityViewContainer = ({ children, viewParams, onViewChange, title }) => {
    const { id } = useParams();
    const { stakeholderGroupId } = useApplicationReference(Number(id));
    const navigate = useNavigate();
    const apps = useDataSecurityApps(false, true);
    const appsLoaded = useSonarSelector(useDataSecurityApps.selectors.dataExists);
    useOnMount(() => {
        onViewChange({ appGroup: stakeholderGroupId });
    });
    const onAppSelect = useCallback((appId) => {
        navigate(`${FULL_ROUTES.DATA_SECURITY}${appId ? `/${appId}` : ''}`);
    }, [navigate]);
    const onDateChange = useCallback((dateRange) => {
        onViewChange({ dateRange });
    }, [onViewChange]);
    const onAppGroupChange = useCallback((userSelectedGroup) => {
        onViewChange({ userSelectedGroup });
        navigate(FULL_ROUTES.DATA_SECURITY);
    }, [navigate, onViewChange]);
    useEffect(() => {
        if (id && appsLoaded && !apps.some((app) => app.applicationId === Number(id))) {
            navigate(FULL_ROUTES.DATA_SECURITY);
        }
    });
    return (React.createElement(VerticalColumnView, { collapseSidebar: true, id: 'data-security-view-container', loading: !appsLoaded },
        React.createElement(SonarCard, { className: 'data-security-view-header', extra: React.createElement(Space, null,
                React.createElement(AppSelect, { getPopupContainer: getClosestCardHeader, includeDetected: true, onChange: onAppSelect, value: id ? Number(id) : undefined }),
                React.createElement(AppGroupSelect, { getPopupContainer: getClosestCardHeader, onChange: onAppGroupChange, value: viewParams.appGroup }),
                React.createElement(DateRangePicker, { endDate: viewParams.dateRange.end, onChange: onDateChange, startDate: viewParams.dateRange.start })), title: title }),
        React.createElement(Row, { gutter: 8 }, children)));
};
